import { createRouter, createRootRoute } from '@tanstack/react-router'
import { buildClubhouseRoutes, RootErrorBoundary, useActiveDistrict } from '@wehunt/clubhouse-web-viltrapport'
import { buildStatisticsRoutes } from '@wehunt/chronicle-web-viltrapport'

function ErrorThrower({ error }: { error: unknown }): never { throw error }

function RootErrorAdapter({ error }: { error: unknown }) {
  return (
    <RootErrorBoundary>
      <ErrorThrower error={error} />
    </RootErrorBoundary>
  )
}

const rootRoute = createRootRoute({ errorComponent: RootErrorAdapter })

// Composition root: clubhouse and chronicle are sibling domains that never
// import each other (RULE-002). The app stitches chronicle's statistics
// routes under clubhouse's authenticated shell. No auth bridge is needed here
// any more: chronicle's useAuth (like clubhouse's) is a re-export of
// @wehunt/core-web's useAuth, so both read the same context off the single
// AuthProvider mounted at the app root in main.tsx.
//
// Statistics are scoped to the area chosen in clubhouse's switcher. Chronicle cannot
// read clubhouse's store, so the shell hands the hook across here.
function useActiveDistrictId(): string | null {
  return useActiveDistrict().activeDistrictId
}

const routeTree = rootRoute.addChildren(
  buildClubhouseRoutes(rootRoute, {
    extraRoutes: [(parent) => buildStatisticsRoutes(parent, { useActiveDistrictId })],
  }),
)

export const router = createRouter({ routeTree, defaultPreload: 'intent' })
